import containerQueries from '@tailwindcss/container-queries';
import forms from '@tailwindcss/forms';
import typography from '@tailwindcss/typography';
import { colors } from './theme/colors.js';
const spacer = 1;
export default {
    content: ['./src/**/*.{html,js,svelte,ts,css}'],
    theme: {
        screens: {
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '2xl': '1536px'
        },
        colors: colors,
        fontFamily: {
            body: `var(--font-body)`,
            display: `var(--font-display)`
        },
        container: {
            center: true,
            padding: {
                DEFAULT: '1rem',
                xl: '4rem'
            }
        },
        spacing: {
            mainNav: '6.29rem',
            auto: 'auto',
            0: '0',
            px: '1px',
            1: `${spacer / 4}rem`,
            1.5: `0.375rem`,
            2: `${spacer / 2}rem`,
            2.5: `0.625rem`,
            3: `${spacer}rem`,
            3.5: `${spacer * 1.25}rem`,
            4: `${spacer * 1.5}rem`,
            5: `${spacer * 2}rem`,
            6: `${spacer * 3}rem`,
            7: `${spacer * 7}rem`,
            8: `${spacer * 14}rem`
        },
        iconSizes: {
            small: 3,
            default: 5,
            big: 6
        },
        maxWidth: (theme, { breakpoints }) => {
            return {
                none: 'none',
                xs: '20rem',
                sm: '24rem',
                md: '28rem',
                lg: '32rem',
                xl: '36rem',
                '2xl': '42rem',
                '3xl': '48rem',
                '4xl': '56rem',
                '5xl': '64rem',
                '6xl': '72rem',
                full: '100%',
                ...theme('spacing'),
                ...breakpoints(theme('screens'))
            };
        },
        extend: {
            aspectRatio: {
                '9/16': '9 / 16'
            },
            transitionProperty: {
                height: 'height'
            },
            zIndex: {
                '-1': '-1',
                1: '1',
                'preloading-spinner': '1993',
                nav: '1994',
                'modal-1': '1995',
                'modal-2': '1996',
                'modal-3': '1997',
                dropdown: '1998',
                tooltip: '1999',
                max: '2000'
            },
            opacity: {
                90: '90%'
            },
            borderRadius: {
                xl: '1rem'
            },
            top: {
                '100%': '100%'
            },
            width: {
                30: `30%`,
                45: `45%`
            },
            maxWidth: (theme) => ({
                ...theme('spacing')
            })
        }
    },
    plugins: [typography, forms, containerQueries]
};
